import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, booleanAttribute, forwardRef, inject } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import type { KeyValueSelect } from '@shared/interfaces/key-value-select.interface';
interface Opciones {
  key: number | string;
  value: number | string;
}

interface ItemsInput {
  [key: string]: Opciones[];  // Las claves son variables y de tipo string
}
@Component({
  selector: 'so-group-select-reactive-form',
  templateUrl: './so-group-select-reactive-form.component.html',
  styleUrl: './so-group-select-reactive-form.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SoGroupSelectReactiveForm),
      multi: true
    }
  ]
})
export class SoGroupSelectReactiveForm implements OnInit, OnChanges {
  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectionText: EventEmitter<any> = new EventEmitter<any>();

  @Input() selectLabel: string = '';
  @Input() selectedItemId: number | string | null = null;
  @Input() isLoading: boolean = false;
  @Input() customStyle: string = '';
  @Input() name: string = '';
  @Input({ transform: booleanAttribute }) isWhiteBox: boolean = false;
  @Input({ transform: booleanAttribute }) requiredMark: boolean = false;
  @Input() disabledKeys: any[] = [];
  @Input() isDisabled: boolean = false;
  @Input() isInitiallyEmpty: boolean = false; // Nueva propiedad
  @Input() tooltipDisabledText: string | null = '';
  @Input() formControl: FormControl | null = null;
  @Input() type: 'simple' | 'grouped' = 'simple';

  // @ViewChild('selectElement') selectElementRef!: ElementRef;

  @Input() labelStyle: string = '';

  public elementRef = inject(ElementRef);

  value: any;

  onChange: any = () => {};
  onTouched: any = () => {};

  public _items: ItemsInput = {};

  constructor() {}

  ngOnInit() {
    // this.isInitiallyEmpty = this.selectedItemId === null; // Determinar si estaba vacío inicialmente
  }

  get touched(): boolean {
    return this.formControl?.touched ?? false;
  }

  get valid(): boolean {
    return this.formControl?.valid ?? true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Si se cambian los items y ya no está el actual, reestablecer el id seleccionado
    if (this.isInitiallyEmpty && Object.keys(changes).includes('items')) {
      const currentValue: KeyValueSelect[] | undefined = changes['items'].currentValue;
      if (currentValue && !currentValue.some(item => item.key === this.selectedItemId))
        this.selectedItemId = null;
    }
  }

  shouldBeDisabled(key: any) {
    return this.disabledKeys.some(currentKey => currentKey == key);
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  updateValue(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const newValue = selectElement.value;
    const selectedIndex = selectElement.selectedIndex;
    const selectedOption = selectElement.options[selectedIndex];
    const selectedText =  selectedOption.text;
    
    if (this.isInitiallyEmpty) this.selectedItemId = newValue;
    this.value = newValue;
    this.onChange(newValue);
    this.onTouched();
    this.selectionChange.emit(newValue);
    this.selectionText.emit(selectedText);
  }

  @Input({ required: true }) set items(value: ItemsInput){
    if (value) {
      this._items = value;
    }
  }

  get items(): object {
    return this._items;
  }
  setDisabledState?(isDisabled: boolean): void {
    // Optional: Implementar si necesitas controlar el estado deshabilitado del select
    this.isDisabled = isDisabled;
  }
  getKeys(obj: ItemsInput): string[] {
    return Object.keys(obj);
  }
  trackByIndex(index: number, obj: any): any {
    return index;
  }
}
